import * as React from 'react';
import { ICON_SIZE_MAP } from '../helpers/size.js';
const MutedIcon = React.forwardRef((props, ref) => {
    const sizeKey = props.size !== undefined ? props.size : 1;
    const size = ICON_SIZE_MAP[sizeKey];
    return (React.createElement("svg", { width: size, height: size, fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, viewBox: "0 0 16 16" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M.195 15.805a.664.664 0 0 0 .943 0L15.805 1.138a.666.666 0 1 0-.943-.942L12.666 2.39V1.334A.667.667 0 0 0 11.6.8L6.445 4.667H1.333a.666.666 0 0 0-.666.667v5.333c0 .369.298.666.666.666h2.391L.195 14.862a.666.666 0 0 0 0 .943Zm6.85-4.021L11.6 15.2a.664.664 0 0 0 .698.063.667.667 0 0 0 .368-.596V6.162l-5.621 5.622Z", fill: "currentColor" })));
});
MutedIcon.displayName = 'MutedIcon';
export default MutedIcon;
